<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="site_name" name="site_name" rules="required" v-slot="{ errors }">
              <small class="label">Manufacturing site name</small>
              <vs-input :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="site_name" class="w-full required" label="" v-model="form.site_name"/>

            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="address_line_1" name="address_line_1" rules="required" v-slot="{ errors }">
              <small class="label">Manufacturing Address Line 1</small>
              <vs-input name="address_line1"  class="w-full required" label="" v-model="form.address_line1" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="address_line_2" name="address_line_2" rules="" v-slot="{ errors }">
              <small class="label">Manufacturing Address Line 2</small>
              <vs-input  class="w-full required" label="" v-model="form.address_line2" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="address_line_3" name="address_line_3" rules="" v-slot="{ errors }">
              <small class="label">Manufacturing Address Line 3</small>
              <vs-input  class="w-full required" label="" v-model="form.address_line3" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="town" name="town" rules="required" v-slot="{ errors }">
              <small class="label">Manufacturing Site Town State</small>
              <vs-input  class="w-full required" label="" v-model="form.address_town_state" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="address_post_code" name="address_post_code" rules="required|max:10" v-slot="{ errors }">
              <small class="label">Manufacturing Site Postcode</small>
              <vs-input name="address_post_code"  class="w-full required" label="" v-model="form.address_post_code" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full">
            <ValidationProvider vid="address_country" name="address_country" rules="required" v-slot="{ errors }">
              <small class="label">Country</small>
              <v-select :filter-by="myFilter"  :clearable="false" name="address_country" placeholder="" label="name" v-model="form.address_country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template v-slot:option="option">
                  <span>{{option.name}} </span>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <ValidationProvider vid="site_telephone_code" name="site_telephone_code" rules="required" v-slot="{ errors }">
                  <small class="label">Country Code</small>
                  <v-select label="isd_code" :filter-by="myFilter" :clearable="false" placeholder="code" v-model="form.country_code_site_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.isd_code}} - {{option.name}} </span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/3">
                <ValidationProvider vid="site_telephone" name="site_telephone" rules="required|tel|max:15" v-slot="{ errors }">
                  <small class="label">Telephone Number</small>
                  <vs-input name="site_telephone"  class="w-full required" label="" v-model="form.site_telephone" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <ValidationProvider vid="site_fax_code" name="site_fax_code" rules="" v-slot="{ errors }">
                  <small class="label">Country Code</small>
                  <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="form.country_code_site_fax" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.isd_code}} - {{option.name}} </span>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/3">
                <ValidationProvider vid="site_fax" name="site_fax" rules="fax|max:15" v-slot="{ errors }">
                  <small class="label">Fax No</small>
                  <vs-input name="site_fax"  class="w-full required" label="" v-model="form.site_fax" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full">
            <ValidationProvider vid="email_address" name="Email Address" rules="email" v-slot="{ errors }">
              <small class="label">Email Address</small>
              <vs-input type="email"  class="w-full required" label="" v-model="form.site_email" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <small class="label">Website Address</small>
            <vs-input  class="w-full required" label="" v-model="form.site_website"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <small class="label">Additional Info</small>
            <vs-textarea v-model="form.site_additional_info" />
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  export default {
    name: "SupplierManufacturingHome",
    components: {
      'v-select': vSelect
    },
    data() {
      return {
        form: {},
        id: null,
        countryCodes: []
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      async onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data = (await SupplierManufactureRepository.updateManufactureDetails(this.id, this.form))
          this.showSuccessMessage('Manufacture Site Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async loadCountrCode() {
        const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
        this.countryCodes =  data
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      }
    },
    async mounted() {
      this.$vs.loading()
      this.id = this.$route.params.id
      const {data} = (await SupplierManufactureRepository.getManufactureDetails(this.id)).data
      this.form = data
      this.loadCountrCode()
      this.$vs.loading.close()
    }

  }
</script>

<style scoped>

</style>
